import { useRef, useState } from 'react';
import { Box, IconButton, Stack, Tooltip } from '@mui/material';
import RestartAltIcon from '@mui/icons-material/RestartAlt';

// Same fixed-resolution canvas pattern as the existing signed-buono dialog.
export default function SpaClinicalSignature({ disabled, label, clearLabel, onChange }) {
  const ref = useRef(null); const drawing = useRef(false); const last = useRef(null); const ink = useRef(false);
  const [drawn, setDrawn] = useState(false);
  const point = (event) => { const rect = ref.current.getBoundingClientRect(); return {
    x: (event.clientX - rect.left) * 800 / rect.width, y: (event.clientY - rect.top) * 240 / rect.height,
  }; };
  const stop = () => { if (!drawing.current) return; drawing.current = false;
    if (ink.current) onChange({ signatureDataUrl: ref.current.toDataURL('image/png'), signatureWidth: 800, signatureHeight: 240 });
  };
  return <Stack spacing={1}>
    <Box component="canvas" ref={ref} width={800} height={240} aria-label={label}
      sx={{ display: 'block', width: '100%', height: 'auto', aspectRatio: '10 / 3', bgcolor: '#fff', border: '1px solid', borderColor: 'divider', touchAction: 'none' }}
      onPointerDown={(event) => { if (disabled) return; ref.current.setPointerCapture?.(event.pointerId); drawing.current = true; last.current = point(event); }}
      onPointerMove={(event) => { if (!drawing.current || disabled) return;
        const next = point(event); const ctx = ref.current.getContext('2d'); ctx.strokeStyle = '#111'; ctx.lineWidth = 3; ctx.lineCap = 'round';
        ctx.beginPath(); ctx.moveTo(last.current.x, last.current.y); ctx.lineTo(next.x, next.y); ctx.stroke(); last.current = next; ink.current = true; setDrawn(true);
      }} onPointerUp={stop} onPointerCancel={stop} />
    <Box><Tooltip title={clearLabel}><span><IconButton aria-label={clearLabel} disabled={disabled || !drawn} onClick={() => {
      ref.current.getContext('2d').clearRect(0, 0, 800, 240); ink.current = false; setDrawn(false); onChange(null);
    }}><RestartAltIcon /></IconButton></span></Tooltip></Box>
  </Stack>;
}
